<template>
  <div>
    <vhp-breadcrumb />

    <div class="vhp-main-content-title">
      <h1 class="page-title">{{ $t("제품") }}</h1>
      <p class="page-subtitle mb-4">{{ $t("제품_설명") }}</p>
    </div>

    <div class="page-background flex">
      <img src="@/assets/image/background/bg48.jpg" alt="page-image"/>
    </div>

    <div  v-if="$route.path === '/products'" class="product-container">
      <div class="product-menus" v-if="categories">
          <div
            v-for="(item, index) in categories"
            :key="item.id"
            class="menu"
            :class="categoryIndex === index ? 'active' : ''"
           
          >
            <div style="cursor: pointer; display:flex; flex-direction: row; align-items:center; "  @click="categoryIndex = index, (itemIndex = 0), $router.push('/products?index=' + index)"> 
              {{ $t(item.name)}}
              <i :class="`fas fa-arrow-${categoryIndex === index ? 'right' : 'down'}`" style=" margin-left:auto;"></i>
            </div>


            <ul v-if="categoryIndex === index" >
              <li
                v-for="(product, idx) in filteredProductsTotal" :key="product.title"
                :class="itemIndex === idx ? 'active' : ''"
                @click="$router.push('/products/details?id=' + product.id)"
              >
              {{ product.title }}

              </li>
            </ul>

          </div>
      </div>

      <div class="product-hidden" :style="'height: ' + (parseInt((filteredProducts.length + 1) / 3) + 1) * 450 + 'px;'"></div>

      <div class="product-list-container">
        <h1 class="title" v-if="categories[categoryIndex]">{{ $t(categories[categoryIndex].name) }}</h1>
        <p class="subtitle" v-if="categories[categoryIndex]">{{ categories[categoryIndex].description }}</p>
        <div
          data-aos-duration="800" data-aos="fade"
          class="list"
        >
    
          <template
            v-for="item in filteredProducts"
            :key="item.title"
          >
            <div class="content-card"
            >
              <div class="card-wrap"
                data-aos-duration="400"
                data-aos="fade-up"
              >
                <div
                  class="card-image"
                  @click="$router.push('/products/details?id=' + item.id)"
                >
                  
                  <img  v-if="item.image || item.thumbnail" :src="item.image || item.thumbnail"  />
                  
                  <img v-else src="@/assets/image/etc/noimage.png"/>
                </div>

                <div
                  class="item-description"
                >
              
                  <h2>
                    {{ item.title }}
                  </h2>

                  <p>
                    {{ item.subtitle }}
                  </p>

                </div>
                
              </div>
            </div>
          </template>

          <div class="content-card"
            v-if="!loadingProducts"
          >
              <div class="card-wrap"
                data-aos-duration="400"
                data-aos="fade-up"
              >
                <div
                  class="card-image"
                  @click="$router.push('/contact')"

                >
                  <img src="@/assets/image/etc/contact.png"  />
                </div>

                <div
                  class="item-description"
                >
              
                  <h2>
                    {{$t('도입/견적 문의')}}
                  </h2>

                  <p>
                    {{$t('도입/견적 문의_설명')}}
                  </p>
                 
                </div>
                
              </div>
          </div>
        </div>

        <button 
          class="vhp-button" 
          style="margin: 0 auto;"
          data-aos-duration="800"
          data-aos="fade-up" 
          @click="maxViewLength += 9"
          v-if="filteredProductsTotal.length > filteredProducts.length">
            <i class="fas fa-arrow-down mr-2"/>
            {{ $t('더 보기') }} 
        </button>

        
      </div>
    </div>

    <router-view v-else/>


    <!-- <div class="vhp-divider"></div> -->
  </div>
</template>

<script>
export default {
  name: "ProductIndex",
  data() {
    return {
      categoryIndex: 0,
      itemIndex: 0,
      categories: [],
      products:[],
      loadingProducts: false,
      maxViewLength:8,
    };
  },
  mounted() {
    this.categoryIndex = parseInt(this.$route.query.index) || 0
    this.get();
  },
  watch: {
    '$route.query'(){
      this.categoryIndex = parseInt(this.$route.query.index) || 0
    }

  },
  computed:{
    filteredProducts() {
      return this.products.filter((e) => e.category === this.categories[this.categoryIndex].id).splice(0, this.maxViewLength)
    },
    filteredProductsTotal() {
      return this.products.filter((e) => e.category === this.categories[this.categoryIndex].id)
    }
  },
  methods: {
    async get() {
      this.loadingProducts = true;

      await this.getCategory()
      await this.getProducts()

      this.loadingProducts = false;

    },
    async getProducts() {

      await this.$axios
        .get("/product")
        .then((res) => {
          this.products = res.data;
        })
        .catch((err) => {
          console.log(err);
        });

      this.loadingProducts = false;
    },

    async getCategory() {
      const response = await this.$axios.get('/category')
      if(response.data) {
        this.categories = response.data
      }
    }

  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
